import { LuMonitor, LuMoon, LuSun } from 'react-icons/lu'
import { IconButton } from '../components/ui/IconButton.tsx'
import { hint } from '../lib/hint.ts'
import { type ThemePref, useTheme } from './ThemeProvider.tsx'

const ORDER: ThemePref[] = ['system', 'light', 'dark']
const META = {
  system: { icon: LuMonitor, label: 'System' },
  light: { icon: LuSun, label: 'Light' },
  dark: { icon: LuMoon, label: 'Dark' },
} as const

/** Cycles System → Light → Dark. */
export function ThemeToggle() {
  const { pref, setPref } = useTheme()
  const next = ORDER[(ORDER.indexOf(pref) + 1) % ORDER.length] as ThemePref
  const { icon: Icon, label } = META[pref]

  return (
    <IconButton
      data-tour="theme-toggle"
      aria-label={`Theme: ${label}. Switch to ${META[next].label}`}
      onClick={() => setPref(next)}
      {...hint(`Theme: ${label} (click for ${META[next].label.toLowerCase()})`)}
    >
      <Icon />
    </IconButton>
  )
}
